// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Security-module__activateSection___tPvyt {
  margin-top: 32px;
  border-top: 1px solid #eee;
  padding-top: 24px;
  width: 100%;
}

.Security-module__activateTitle___X0f8Z {
  font-weight: 600;
  margin-bottom: 12px;
  color: #375844;
}

.Security-module__activateActions___kUcAZ {
  display: flex;
  gap: 16px;
}

.Security-module__button___hnv3g {
  height: 38px;
  margin: 16px 0 0 0;
  width: auto;
  align-self: start;
}

.Security-module__form___gA4ri {
  padding: 27px 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 6px;
}

.Security-module__passwordSection___ZpJ3R {
  width: 100%;
  margin-bottom: 16px;
}

.Security-module__sectionTitle___l7LrN {
  font-weight: 600;
  margin-bottom: 12px;
  color: #375844;
}`, "",{"version":3,"sources":["webpack://./src/pages/PatientDetails/fragments/Security/Security.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,WAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;AACF;;AAEA;EACE,YAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,QAAA;AACF;;AAEA;EACE,WAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;EACA,cAAA;AACF","sourcesContent":[".activateSection {\n  margin-top: 32px;\n  border-top: 1px solid #eee;\n  padding-top: 24px;\n  width: 100%;\n}\n\n.activateTitle {\n  font-weight: 600;\n  margin-bottom: 12px;\n  color: #375844;\n}\n\n.activateActions {\n  display: flex;\n  gap: 16px;\n}\n\n.button {\n  height: 38px;\n  margin: 16px 0 0 0;\n  width: auto;\n  align-self: start;\n}\n\n.form {\n  padding: 27px 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 6px;\n}\n\n.passwordSection {\n  width: 100%;\n  margin-bottom: 16px;\n}\n\n.sectionTitle {\n  font-weight: 600;\n  margin-bottom: 12px;\n  color: #375844;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"activateSection": `Security-module__activateSection___tPvyt`,
	"activateTitle": `Security-module__activateTitle___X0f8Z`,
	"activateActions": `Security-module__activateActions___kUcAZ`,
	"button": `Security-module__button___hnv3g`,
	"form": `Security-module__form___gA4ri`,
	"passwordSection": `Security-module__passwordSection___ZpJ3R`,
	"sectionTitle": `Security-module__sectionTitle___l7LrN`
};
module.exports = ___CSS_LOADER_EXPORT___;
